import React, { useRef, useState } from 'react';
import { PinturaEditor } from 'react-pintura';
import 'pintura/pintura.css';
import { IoCloseSharp } from 'react-icons/io5';
import {
  createDefaultColorOptions,
  createDefaultImageReader,
  createDefaultImageScrambler,
  createDefaultImageWriter,
  createDefaultShapePreprocessor,
  createMarkupEditorToolStyle,
  createMarkupEditorToolStyles,
  // eslint-disable-next-line camelcase
  locale_en_gb,
  // eslint-disable-next-line camelcase
  markup_editor_defaults,
  // eslint-disable-next-line camelcase
  markup_editor_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_annotate,
  // eslint-disable-next-line camelcase
  plugin_annotate_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_crop,
  // eslint-disable-next-line camelcase
  plugin_crop_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_filter,
  // eslint-disable-next-line camelcase
  plugin_filter_defaults,
  // eslint-disable-next-line camelcase
  plugin_filter_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_finetune,
  // eslint-disable-next-line camelcase
  plugin_finetune_defaults,
  // eslint-disable-next-line camelcase
  plugin_finetune_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_frame,
  // eslint-disable-next-line camelcase
  plugin_frame_defaults,
  // eslint-disable-next-line camelcase
  plugin_frame_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_redact,
  // eslint-disable-next-line camelcase
  plugin_redact_locale_en_gb,
  // eslint-disable-next-line camelcase
  plugin_sticker,
  // eslint-disable-next-line camelcase
  plugin_sticker_locale_en_gb,
  setPlugins,
} from 'pintura';
import styled from 'styled-components';
import { BigButton } from '@/components/big-button';

setPlugins(
  plugin_crop,
  plugin_finetune,
  plugin_filter,
  plugin_annotate,
  plugin_sticker,
  plugin_redact,
  plugin_frame,
);

const editorDefaults = {
  imageReader: createDefaultImageReader(),
  imageWriter: createDefaultImageWriter(),
  imageScrambler: createDefaultImageScrambler(),
  shapePreprocessor: createDefaultShapePreprocessor(),
  // eslint-disable-next-line camelcase
  ...plugin_finetune_defaults,
  // eslint-disable-next-line camelcase
  ...plugin_filter_defaults,
  // eslint-disable-next-line camelcase
  ...plugin_sticker,
  // eslint-disable-next-line camelcase
  ...plugin_redact,
  // eslint-disable-next-line camelcase
  ...plugin_frame_defaults,
  // eslint-disable-next-line camelcase
  ...markup_editor_defaults,
  locale: {
    // eslint-disable-next-line camelcase
    ...locale_en_gb,
    labelButtonExport: `Generate this!`,
    // eslint-disable-next-line camelcase
    ...plugin_crop_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_finetune_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_filter_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_annotate_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_sticker_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_redact_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...plugin_frame_locale_en_gb,
    // eslint-disable-next-line camelcase
    ...markup_editor_locale_en_gb,
    stickerLabel: `Images`,
    annotateLabel: `Sketch`,
    shapeLabelToolPreset: `Components`,
  },
};

const initialImage = `https://sdk.loomi-prod.xyz/VSLY/whiteboard.png`;

export interface ToolWhiteboardImageEditorProps {
  onGenerateItClicked?: (img: File) => void;
  setIsWhiteboardOpen?: (open: boolean) => void;
}

export function ToolWhiteboardImageEditor({
  onGenerateItClicked,
  setIsWhiteboardOpen,
}: ToolWhiteboardImageEditorProps) {
  const componentRef = useRef(null);
  const prevImageBlob = localStorage.getItem(`vsly_wb_blob`) || ``;
  const [loading, setLoading] = useState(false);

  const onGenerate = () => {
    setLoading(true);
    // @ts-ignore
    document.querySelector(`.PinturaButton.PinturaButtonExport`)?.click();
    setLoading(false);
  };

  const onClose = () => {
    setIsWhiteboardOpen(false);
  };

  return (
    <Wrapper>
      <h1>Sketch a component</h1>
      <button type="button" className="close-btn" onClick={onClose}>
        <IoCloseSharp size={26} />
      </button>
      {/* @ts-ignore */}
      <PinturaEditor
        ref={componentRef}
        {...editorDefaults}
        locale={{
          ...editorDefaults.locale,
        }}
        utils={[`annotate`, `sticker`]}
        annotateActiveTool="preset"
        annotatePresets={[
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/header.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/paragraph.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/image.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/button.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/overlay.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/accordion.png`,
            width: 300,
          },
          {
            src: `https://sdk.loomi-prod.xyz/VSLY/sketch/product.png`,
            width: 300,
          },
        ]}
        finetuneControlConfiguration={undefined}
        markupEditorToolStyles={createMarkupEditorToolStyles({
          rectangle: createMarkupEditorToolStyle(`rectangle`, {
            strokeColor: createDefaultColorOptions().black,
            backgroundColor: createDefaultColorOptions().transparent,
            strokeWidth: `0.25%`,
          }),
          ellipse: createMarkupEditorToolStyle(`ellipse`, {
            strokeColor: createDefaultColorOptions().black,
            backgroundColor: createDefaultColorOptions().transparent,
            strokeWidth: `0.25%`,
          }),
          path: createMarkupEditorToolStyle(`path`, {
            strokeColor: createDefaultColorOptions().black,
            backgroundColor: createDefaultColorOptions().transparent,
            strokeWidth: `0.25%`,
          }),
          line: createMarkupEditorToolStyle(`line`, {
            strokeColor: createDefaultColorOptions().black,
            backgroundColor: createDefaultColorOptions().transparent,
            strokeWidth: `0.25%`,
          }),
          sharpie: createMarkupEditorToolStyle(`path`, {
            strokeColor: createDefaultColorOptions().black,
            backgroundColor: createDefaultColorOptions().transparent,
            strokeWidth: `0.25%`,
          }),
          text: createMarkupEditorToolStyle(`text`, {
            color: createDefaultColorOptions().black,
            fontSize: `4%`,
          }),
        })}
        cropEnableButtonFlipHorizontal={false}
        cropEnableButtonFlipVertical={false}
        cropEnableButtonRotateLeft={false}
        cropEnableButtonRotateRight={false}
        cropEnableButtonToggleCropLimit={false}
        cropEnableImageSelection={false}
        cropEnableInfoIndicator={false}
        cropEnableLimitWheelInputToCropSelection={false}
        cropEnableRotationInput={false}
        cropEnableSelectPreset={false}
        cropEnableZoomInput={false}
        cropEnableZoomAutoHide={false}
        cropEnableCenterImageSelection={false}
        onLoad={(_) => {
          URL.revokeObjectURL(prevImageBlob);
        }}
        layoutDirectionPreference="vertical"
        layoutHorizontalUtilsPreference="bottom"
        src={initialImage}
        onProcess={({ dest }: any) => {
          const file = new File([dest], `whiteboard.png`, {
            type: dest.type,
            lastModified: Date.now(),
          });
          onGenerateItClicked?.(file);
          setIsWhiteboardOpen(false);
        }}
      />
      <div className="footer">
        <BigButton
          disabled={loading}
          background="#FFFFFF"
          color="#8C9BA8"
          border="1px solid #A6AFB8"
          noTransform
          fillWidth
          noShadow
          size="medium"
          onClick={onClose}
        >
          Discard
        </BigButton>
        <BigButton
          disabled={loading}
          background="#334BFF"
          color="#FFFFFF"
          noTransform
          fillWidth
          noShadow
          size="medium"
          onClick={onGenerate}
        >
          Generate it
        </BigButton>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;

  .PinturaRoot {
    background-color: white;
  }

  .PinturaButton.PinturaButtonExport {
    visibility: hidden;
  }

  .PinturaShapePresetsList .PinturaShapePreset img {
    height: 50px;
    width: 70px;
    object-fit: contain;
  }

  .PinturaShapePresetsList .PinturaShapePreset .PinturaDragButton {
    padding: 0;
    box-shadow: none;
  }

  h1 {
    width: 100%;
    text-align: center;
    font-size: 2rem;
    margin: 0rem 0;
    padding: 0;
  }

  .close-btn {
    cursor: pointer;
    appearance: none;
    outline: none;
    border: none;
    position: absolute;
    top: 0rem;
    right: 2rem;
  }

  .footer {
    display: grid;
    width: 70%;
    grid-template-columns: 1fr 2fr;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    justify-items: center;
    align-content: center;
    align-self: center;
    justify-self: center;
    padding: 2rem 0;
    gap: 2rem;
  }
`;
